<template>
  <div class="index">
    <img src="../assets/title.png" alt="" class="title" />
    <img src="../assets/dtBtn.png" alt="" class="dtBtn" @click="toAnswer()" />
    <div class="btnGroup">
      <img src="../assets/smBtn.png" alt="" @click="toDescription()" />
      <img src="../assets/jpBtn.png" alt="" @click="toSetPrize()" />
    </div>
    <p>北京市生态环境保护宣传中心</p>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {};
  },
  mounted() {
    this.getClicks();
  },
  methods: {
    getClicks() {
      this.$axios({
        methods: "get",
        url: "http://wstq.scimall.org/portal/clicks/index",
        data: {
          h5Name: "answerVue",
        },
      })
        .then((res) => {})
        .catch((err) => {});
    },
    toDescription() {
      this.$router.push({
        path: "/description",
      });
    },
    toSetPrize() {
      this.$router.push({
        path: "/setPrize",
      });
    },
    toAnswer() {
      this.$router.push({
        path: "/answer",
      });
    },
  },
};
</script>

<style lang="less" scoped>
.index {
  width: 100vw;
  height: 100%;
  position: relative;
  .title {
    width: 100%;
    margin-top: 18vh;
  }
  .dtBtn {
    width: 40vw;
    display: block;
    margin: 5vh auto;
  }
  .btnGroup {
    position: absolute;
    top: 3vh;
    right: 3vw;
    width: 30vw;
    img {
      width: 100%;
    }
  }
  p {
    color: rgb(25, 96, 4);
    font-weight: 800;
    font-size: 4vw;
    width: 100%;
    text-align: center;
    margin: 15vh auto;
  }
}
</style> 



// WEBPACK FOOTER //
// src/pages/index.vue